import React from 'react';

// Modules
import PublicTopBar from '../publicTopBar/PublicTopBar';
import EventParticipantList from '../shared/eventParticipantList/EventParticipantList';
import { Divider, Tabs, Button, Modal } from 'antd';
import EventRegistrationForm from '../shared/eventRegistrationForm/EventRegistrationForm';

// Style
import './Event.css';

export default (props) => {
    return (
        <div>
            <PublicTopBar />

            <div className='eventImgBg' style={{ backgroundImage: `url(${props.event && props.event.img})` }} />

            <div className='eventCentralDiv'>
                <h4>{props.event && props.event.nome}</h4>

                <p>
                    <b style={{ fontSize: 'larger' }}>{props.event && props.event.descricao}</b>
                </p>

                <Divider />

                <p>
                    {props.event && props.event.observacao}
                </p>

                {props.event && props.event.doc ?
                    <a href={props.event.doc} target='blank'>Edital do campeonato</a> :
                    null
                }

                {props.event && props.event.registrationStatus !== 'finish' ?
                    <Button
                        type='primary'
                        style={{ marginRight: '10px' }}
                        onClick={() => props.openModalRegistration()}
                    >Se inscreva</Button>
                    : null
                }

                <Divider />

                <Tabs defaultActiveKey="1">
                    <Tabs.TabPane tab="Participantes" key="1">
                        {
                            props.eventId ?
                                <EventParticipantList
                                    event={props.event}
                                    eventId={props.eventId}
                                    studentsList={props.studentsList}
                                    updateStudentList={() => props.updateStudentList()}
                                /> : null
                        }
                    </Tabs.TabPane>

                </Tabs>
            </div>

            {/* Registration Modal */}
            <Modal
                title='Inscrição'
                visible={props.modalRegistration}
                onCancel={props.closeModalRegistration}
                width='600px'
                footer={[
                    <Button key='close' onClick={props.closeModalRegistration}>Fechar</Button>
                ]}
            >
                <EventRegistrationForm
                    arrayOfTeams={props.arrayOfTeams}
                    eventInfo={props.event}
                    eventId={props.eventId}
                    updateStudentList={() => props.updateStudentList()}
                />
            </Modal>
        </div>
    );
}